import { EVALUATION_EXPORT_TIMEOUT_MS } from 'shared/constants/evaluation';
import {
  CreateEvaluationDto,
  EvalsGenerateSingleStepQuestionsDto,
  EvalsGenerateSingleStepQuestionsResponseDto,
  Evaluation,
  ExportEvaluationDto,
  RunEvaluationDto
} from 'shared/interfaces/Evaluation';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const evaluationBaseEndpoint = '/evaluation';

export const EvaluationService = {
  createEvaluation: async (evaluation: CreateEvaluationDto): Promise<Evaluation> => {
    const response = await axiosBaseInstance.post(evaluationBaseEndpoint, evaluation);
    return response.data as Evaluation;
  },

  getEvaluationsForSmartAssistant: async (smartAssistantId: string): Promise<Evaluation[]> => {
    const response = await axiosBaseInstance.get(evaluationBaseEndpoint, { params: { smartAssistantId } });
    return response.data as Evaluation[];
  },

  getEvaluationById: async (evaluationId: string): Promise<Evaluation> => {
    const response = await axiosBaseInstance.get(`${evaluationBaseEndpoint}/${evaluationId}`);
    return response.data as Evaluation;
  },

  deleteEvaluation: async (evaluationId: string): Promise<Evaluation> => {
    const response = await axiosBaseInstance.delete(`${evaluationBaseEndpoint}/${evaluationId}`);
    return response.data as Evaluation;
  },

  runEvaluation: async (evaluationId: string, runEvaluationDto: RunEvaluationDto): Promise<Evaluation> => {
    const response = await axiosBaseInstance.post(`${evaluationBaseEndpoint}/${evaluationId}/run`, runEvaluationDto);
    return response.data as Evaluation;
  },

  resetEvaluation: async (evaluationId: string, createEvaluationDto: CreateEvaluationDto): Promise<Evaluation> => {
    const response = await axiosBaseInstance.post(
      `${evaluationBaseEndpoint}/${evaluationId}/reset`,
      createEvaluationDto
    );
    return response.data as Evaluation;
  },

  generateSingleStepQuestions: async (
    generateQuestionsDto: EvalsGenerateSingleStepQuestionsDto
  ): Promise<EvalsGenerateSingleStepQuestionsResponseDto> => {
    const response = await axiosBaseInstance.post(
      `${evaluationBaseEndpoint}/generate/single-step-questions`,
      generateQuestionsDto
    );
    return response.data as EvalsGenerateSingleStepQuestionsResponseDto;
  },

  exportEvaluation: async (evaluationId: string, exportEvaluationDto: ExportEvaluationDto): Promise<ArrayBuffer> => {
    const response = await axiosBaseInstance.post(
      `${evaluationBaseEndpoint}/${evaluationId}/export`,
      exportEvaluationDto,
      {
        responseType: 'arraybuffer',
        timeout: EVALUATION_EXPORT_TIMEOUT_MS
      }
    );
    return response.data;
  }
};
